import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import isNumber from 'lodash/isNumber';

import { Text } from '../../../Elements/Elements';

import classes from './Trend.module.scss';

const Trend = ({ trend }) => {
  return (
    <Text className={classes.trend}>
      <span
        className={cn(
          classes.arrow,
          trend > 0 ? classes.arrow_up : trend < 0 ? classes.arrow_down : null
        )}
      />
      <span className={classes.visually_hidden}>
        {trend > 0 ? (
          <> shows that the trend has grown by </>
        ) : trend < 0 ? (
          <> shows that the trend has fallen by </>
        ) : (
          <> shows that the trend has not changed</>
        )}
      </span>
      <Text
        className={cn(
          trend > 0 ? classes.trend_up : trend < 0 ? classes.trend_down : null
        )}
        size={8}
        weight="m"
      >
        {trend < 0 ? trend * -1 : trend}
        {trend !== 0 && isNumber(trend) && '%'}
      </Text>
    </Text>
  );
};

Trend.propTypes = {
  trend: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default Trend;
